import React from 'react';
import CustomSelect from './components/CustomSelect';
import NativeSelect from './components/NativeSelect';
import WhenDesktop from './components/WhenDesktop';
import type ISelect from './shared/types/select';

export default function Select({ onChange, options, size = 'md', ...rest }: ISelect) {
    return (
        <>
            {/* When NOT desktop show native select */}
            <WhenDesktop negate>
                <NativeSelect options={options} onChange={onChange} size={size} {...rest} />
            </WhenDesktop>

            {/* When desktop show custom select */}
            <WhenDesktop>
                <CustomSelect options={options} onChange={onChange} size={size} {...rest} />
            </WhenDesktop>
        </>
    );
}
